import { createSagasForBasicCall } from "core/sagas";
import log from "loglevel";
import { call, put, takeLatest } from "redux-saga/effects";
import FilmReleaseService from "services/filmReleaseService";
import { actions } from "./adActions";

export function* requestUnreportedCount({ payload }) {
    try {
        const result = yield call(FilmReleaseService.getUnreportedCount, payload);
        const count = result || 0;

        yield put(actions.SET_UNREPORTED_COUNT.success({ unreportedCount: count }));
    } catch (error) {
        log.error(error);
    }
}
export default [
    ...createSagasForBasicCall(actions),
    takeLatest(actions.SET_UNREPORTED_COUNT.sendType, requestUnreportedCount),
];
